(function() {
    'use strict';

    /**
     * Manages user's state.
     */

    angular
        .module("pwc.state")
        .service("UserStore", UserStore);

    UserStore.$inject = ['$window', 'lodash', '$log'];

    function UserStore($window, lodash, $log){

        /* jshint validthis: true */
        var self = this;

        self.state = {
            hasPendingChanges: false
        };

        /** initialize */
        initialize();

        /** begin methods */

        function initialize(){

        }
    }

})();
